module.exports = __webpack_public_path__ + "media/images/sugerencias-75cdb714fc62d81d87bba2e15cbb8204.png";